import React from "react";
import { Divider, List, makeStyles, Paper, Theme } from "@material-ui/core";
import QueryString from "query-string";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useHistory } from "react-router-dom";

import { SIDEBAR_LINKS } from "MainRoutes";
import { NavItem } from "./NavItem";
import ConfirmDialog from "../../ConfirmDialog";
import Image from "components/Image";
import { useDispatch } from "react-redux";
import { USER_ACTIONS } from "redux/reducers/userReducer";

export const SIDEBAR_WIDTH = 256;
const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
    desktopSidebar: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: palette.primary.main,
        // paddingTop: spacing(2),
        position: "relative",
    },
    listWrapper: {
        width: "100%",
    },
    logo: {
        display: "flex",
        alignItems: "center",
        height: "64px", // same as AppBar
        margin: spacing(0, 0, 2, 4),
    },
}));

export function SideBar() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const [showConfirmModal, setShowConfirmModal] = React.useState(false);
    const queryParams = QueryString.parse(history.location.search);
    const isStaffTablet = queryParams["isStaffTablet"] === "true";

    return (
        <>
            {showConfirmModal && (
                <ConfirmDialog
                    content="Do you want to log out from Support Tooling Dashboard?"
                    open={showConfirmModal}
                    onSuccess={() => {
                        dispatch({ type: USER_ACTIONS.logout.toString() });
                    }}
                    onCancel={() => setShowConfirmModal(false)}
                    confirmText="Yes, logout"
                    cancelText="Cancel"
                />
            )}
            <Paper className={classes.desktopSidebar} elevation={0} square>
                <div className={classes.logo}>
                    <Image url="/images/presto_logo.svg" alt="Presto Logo" />
                </div>
                {/* <RestaurantPicker /> */}
                <List className={classes.listWrapper}>
                    {SIDEBAR_LINKS.map((item) => (
                        <NavItem
                            href={item.href}
                            key={item.title}
                            title={item.title}
                            icon={item.icon}
                        />
                    ))}
                </List>
                {!isStaffTablet && (
                    <>
                        <Divider />
                        <List className={classes.listWrapper}>
                            <NavItem
                                title="Log Out"
                                icon={ExitToAppIcon}
                                onClick={() => {
                                    setShowConfirmModal(true);
                                }}
                            />
                        </List>
                    </>
                )}
            </Paper>
        </>
    );
}
